<template>
    <div class="tw-flex tw-flex-col">
        <!-- pending requests -->
        <div class="tw-flex tw-flex-col">
            <template v-if="invites_loaded">
                <sidebar-action-btn @clicked="openPopup('send_invites')">
                    <i class="far fa-envelope-open secondary-c"></i>
                    <p>{{ $t('groups.sent_invites') }} ({{ total_invites }})</p>
                </sidebar-action-btn>
            </template>
        </div>

        <modal v-if="popup_open && popup_name === 'send_invites'" modal_name="send_invites" type="medium" :title="$t('groups.sent_invites') + ' (' + total_invites + ')'" icon="envelope-open">
            <template v-slot:modal-content>
                <template v-if="filteredInvites.length > 0">
                    <div class="tw-mb-4" v-for="invite in filteredInvites" :key="invite.id">
                        <div class="tw-flex tw-justify-between">
                            <a :href="'/profile/' + invite.user.username" class="tw-flex tw-items-center tw-justify-center" target="_blank">
                                <user-avatar class="tw-mr-4" :avatar="invite.user.avatar"></user-avatar>
                                <p class="tw-font-semibold hover:tw-underline">
                                    {{ invite.user.username }}
                                </p>
                            </a>

                            <div class="tw-flex items-center tw-mt-1 tw-cursor-pointer">
                                <clickable-icon bg_color="gray-200" color="tw-text-gray-500" size="extra-small" @clicked="remove(invite)">
                                    <i class="fal fa-times"></i>
                                </clickable-icon>
                            </div>
                        </div>
                    </div>
                    <div class="tw-mt-5 tw-flex tw-justify-center tw-text-center tw-cursor-pointer secondary-c hover:tw-underline" :class="{'tw-opacity-25': currently_paginating}" @click="startPagination(false)" v-if="!pagination_failed && initial_pagination_finished && !lastPage">
                        {{ $t('groups.show_more') }}
                    </div>
                </template>
                <template v-else>
                    <p class="tw-text-sm">{{ $t('groups.no_open_invites') }}.</p>
                </template>
            </template>
            <template v-slot:modal-bottom>
                <div class="subtle-button slim" @click="closePopup">
                    {{ $t('fields.close') }}
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    import SimplePagination from '../../../mixins/SimplePagination';
    import Modal from '../../../mixins/v2/Modal';
    import Global from '../../../mixins/Global';
    import Notification from '../../../lib/models/Notification';

    export default {
        name: 'SentInvites',

        mixins: [SimplePagination, Global, Modal],

        props: {
            model_id: {
                required: true,
            },
            endpoint_name: {
                required: true,
            },
        },

        data() {
            return {
                invites: [],
                invites_loaded: false,
                total_invites: 0,
                pagination_settings: {
                    infinite_scroll: false,
                },
            };
        },

        computed: {
            filteredInvites() {
                const _filteredInvites = this.invites.filter(invite => (typeof invite !== 'undefined' && invite.user !== null));

                _filteredInvites.forEach((invite) => {
                    if(!invite.hasOwnProperty('user')) {
                        invite.user = {};
                        invite.user.username = 'Verwijderde gebruiker';
                        invite.user.avatar = 'https://www.gravatar.com/avatar/d41d8cd98f00b204e9800998ecf8427e?s=80&d=mm&r=g';
                    }
                });

                return _filteredInvites;
            },
        },

        methods: {
            paginate() {
                const url = `/api/v3/${this.endpoint_name}/${this.model_id}/invite`;
                const params = new URLSearchParams();

                params.append('page', this.pagination.current_page ? this.pagination.current_page += 1 : 1);

                const request = {
                    params,
                };

                return new Promise((resolve, reject) => {
                    axios.get(url, request).then((result) => {
                        this.invites = this.invites.concat(result.data.data);
                        this.invites_loaded = true;
                        this.total_invites = result.data.meta.total;
                        resolve(result);

                        this.refreshStickySidebar();
                    }).catch(() => {
                        alert('Send invites could not be loaded, please try again later or contact an administrator.');
                        reject();
                    })
                });
            },

            remove(invite) {
                const index = this.invites.findIndex(send_invite => send_invite.id === invite.id);

                axios.post(`/api/v3/${this.endpoint_name}/${this.model_id}/invite/${invite.id}/decline`, {status: 'rejected'}).then(() => {
                    this.invites.splice(index, 1);

                    Notification.insert({
                        data: [
                            {
                                title: 'Invite cancelled.',
                            },
                        ],
                    });
                });
            },
        },
    };
</script>
